import { render } from "./Meigara.vue?vue&type=template&id=a5f2c6b4"
import script from "./Meigara.vue?vue&type=script&lang=js"
export * from "./Meigara.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__